
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school",
      function () {
        return require("private-next-pages/school/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/school"])
      });
    }
  